import { Dialog } from "primereact/dialog";
import React, { useEffect, useRef, useState } from "react";
import {
    setCreateProjectModalVisible,
    setOnCreateProject,
    addEditVcompProject,
    setRespProjectDelete,
    setRespProjectSaved,
    deleteProject,
    getBankAptitudesOnCreation,
    addDefaultProjectForm,
    reorderProjectForm,
    addEditCategory,
    addEditAptitude,
    setAddedAptitudes,
    getProjectAptitudes,
    setProjectAptitudes,
    setProjectMode,
    setAddElementModalVisibility,
    getProjects,
    setRespProjectElement,
    setRespProjectDefForm,
    deleteProjectCatSub,
    deleteProjectAptitude,
    addRemoveProjectCollabsManagers,
    getCollabsNames,
    getProjectMembersAndManagers,
    setRespProjectMembers,
    setAddMembersModalVisibility,
    setAddMembersMode,
    getProjectProgress,
    setProjectProgress,
    setProjectProgressDetails,
    setProjectMembers,
    setProjectManagers,
    setSelectedAptitudeForQuestion,
    activateMcqCollabs,
    setCollabMcqModalVisibility,
    setCollabIdMcqResults,
    setCollabMcqResultsModalVisibility,
    setSessionEndDate,
    setSessionStartDate,
    setLastResponseNumber,
    setAddQuestionModalVisibility,
    getProjectQuestionsBank,
    addEditQuestion,
    setAddQuestionFromTree
} from "./vcompSlice";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { Col, Row } from "react-bootstrap";
import styles from './VcompCompnents.module.css';
import { confirmDialog } from '../popups/ConfirmDialog';
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import moment from "moment";
import addIcon from '../../assets/images/addIconGray.png';
import addIconFocus from '../../assets/images/addIconOrange.png';
import deleteIcon from '../../assets/images/delete.png';
import deleteIconFocus from '../../assets/images/delete-orange.png';
import editIcon from '../../assets/images/penGray.png';
import editIconFocus from '../../assets/images/penOrange.png';
import ImageButton from "../buttons/ImageButton";
import AddElementModal from "./AddElementModal";
import AddMembersModal from "./AddMembersModal";
import McqResultsModal from "./McqResultsModal";
import ExcelInputModal from "./excelInputModal";
import ExcelManager from '../../app/managers/excelManager';

// Extracted sub-components
import {
    ProjectDetailsTab,
    PublicFormTab,
    QuestionsTab,
    EditFormTab,
    MembersTab,
    ManagersTab,
    ProgressTab,
    NavigationMenu,
} from "./createProjectModalComponents";


export default function CreateProjectModal() {

    const dispatch = useDispatch();

    const visible = useSelector((state) => state.vcomp.createProjectModalVisible);
    const isMobile = useSelector((state) => state.settings.isMobile);
    const onCreateProject = useSelector((state) => state.vcomp.onCreateProject);
    const respProjectSaved = useSelector((state) => state.vcomp.respProjectSaved);
    const respProjectDelete = useSelector((state) => state.vcomp.respProjectDelete);
    const respProjectElement = useSelector((state) => state.vcomp.respProjectElement);
    const respProjectDefForm = useSelector((state) => state.vcomp.respProjectDefForm);
    const respProjectMembers = useSelector((state) => state.vcomp.respProjectMembers);
    const bankAptitudesOnCreation = useSelector((state) => state.vcomp.bankAptitudesOnCreation);
    const projectAptitudes = useSelector((state) => state.vcomp.projectAptitudes);
    const mode = useSelector((state) => state.vcomp.projectMode);
    const managersIds = useSelector((state) => state.vcomp.projectManagers);
    const collabsIds = useSelector((state) => state.vcomp.projectCollabs);
    const collabsNames = useSelector((state) => state.vcomp.collabsNames);

    const fileInputRef = useRef(null);
    const categoriesMenuRef = useRef(null);
    const dtCollabs = useRef(null)
    const dtManagers = useRef(null)

    const [activeIndex, setActiveIndex] = useState(0);
    const [isInDatabase, setIsIOnDatabase] = useState(false);
    const [datesList, setDatesList] = useState([]);
    const [addedApt, setAddedApt] = useState([])
    const [nodes, setNodes] = useState([]);
    const [nodesInProject, setNodesInProject] = useState([])
    const [selectedKeys, setSelectedKeys] = useState(null);
    const [excludedKey, setExcludedKey] = useState([])
    const [collabsList, setCollabsList] = useState([])
    const [mangersList, setMangersList] = useState([])
    const [excelModalVisibility, setExcelModalVisibility] = useState(false)

    const [project, setProject] = useState({
        nom: '',
        start_date: null,
        end_date: null,
        days_limit: 1,
        active: true,
        image_src: null,
        needed_collabs: 0
    });

    const [validFields, setValidFields] = useState({
        nom: false,
        start_date: false,
        tried: false,
    });

    const [expandedKeysEdit, setExpandedKeysEdit] = useState({ '0': true, '0-0': true });
    const expandAll = () => {
        let _expandedKeys = {};

        for (let node of nodesInProject) {
            expandNode(node, _expandedKeys);
        }

        setExpandedKeysEdit(_expandedKeys);
    };

    const collapseAll = () => {
        setExpandedKeysEdit({});
    };

    const expandNode = (node, _expandedKeys) => {
        if (node.children && node.children.length) {
            _expandedKeys[node.key] = true;

            for (let child of node.children) {
                expandNode(child, _expandedKeys);
            }
        }
    }

    // ─── useEffect hooks ────────────────────────────────────────────────

    useEffect(() => {
        if (onCreateProject && onCreateProject.id && !isInDatabase) {
            setProject(onCreateProject);
            setIsIOnDatabase(true);
            dispatch(getBankAptitudesOnCreation())
            dispatch(getCollabsNames())
            dispatch(getProjectMembersAndManagers({ id_project: onCreateProject.id }))
            dispatch(getProjectAptitudes({ id_project: onCreateProject.id }))
            if (mode === 'edit') {
                setActiveIndex(6)
                dispatch(getProjectProgress({ id_project: onCreateProject.id, session: onCreateProject.last_session_number }))
            }
            setValidFields({
                nom: true,
                start_date: true,
                tried: false,
            })
        }
    }, [onCreateProject]);

    useEffect(() => {
        if (respProjectSaved != null) {
            if (respProjectSaved.trim().toLowerCase().includes("successfully")) {
                dispatch(getProjects())
                showSuccessToast(respProjectSaved);
                if (mode != 'edit') {
                    setActiveIndex(activeIndex >= 4 ? 0 : activeIndex + 1);
                }
            } else {
                showErrorToast(respProjectSaved);
            }
            dispatch(setRespProjectSaved(null));
        }
    }, [respProjectSaved]);

    useEffect(() => {
        if (respProjectDefForm != null) {
            if (respProjectDefForm.trim().toLowerCase().includes("successfully")) {
                if (onCreateProject) {
                    dispatch(getProjectAptitudes({ id_project: onCreateProject.id }))
                }
                showSuccessToast(respProjectDefForm);
                if (mode != 'edit') {
                    setActiveIndex(activeIndex >= 4 ? 0 : activeIndex + 1);
                }
            } else {
                showErrorToast(respProjectDefForm);
            }
            dispatch(setRespProjectDefForm(null));
        }
    }, [respProjectDefForm]);

    useEffect(() => {
        if (respProjectElement != null) {
            if (respProjectElement.trim().toLowerCase().includes("successfully")) {
                dispatch(getBankAptitudesOnCreation())
                if (onCreateProject) {
                    dispatch(getProjectAptitudes({ id_project: onCreateProject.id }))
                }
                showSuccessToast(respProjectElement);
            } else if (respProjectElement.trim().toLowerCase().includes("removed")) {
                if (onCreateProject) {
                    dispatch(getProjectAptitudes({ id_project: onCreateProject.id }))
                }
                showSuccessToast(respProjectElement);
            } else {
                showErrorToast(respProjectElement);
            }
            dispatch(setRespProjectElement(null));
        }
    }, [respProjectElement]);

    useEffect(() => {
        if (respProjectDelete != null) {
            if (respProjectDelete.trim().toLowerCase().includes("successfully")) {
                showErrorToast(respProjectDelete);
                dispatch(getProjects())
            } else {
                showErrorToast(respProjectDelete);
            }
            dispatch(setRespProjectDelete(null));
        }
    }, [respProjectDelete]);

    useEffect(() => {
        if (respProjectMembers != null) {
            if (respProjectMembers.trim().toLowerCase().includes("successfully")) {
                showSuccessToast(respProjectMembers);
                dispatch(getProjectMembersAndManagers({ id_project: onCreateProject.id }))
            } else {
                showErrorToast(respProjectMembers);
            }
            dispatch(setRespProjectMembers(null));
        }
    }, [respProjectMembers]);

    useEffect(() => {
        if (bankAptitudesOnCreation.categories?.length > 0) {
            const excludedKeys = excludedKey;
            const processNode = (node) => {
                const keyPrefix = node.scope === 'category' ? 'cat' :
                    node.scope === 'subcategory' ? 'subcat' : 'apt';
                const key = `${keyPrefix}-${node.id}`;
                let processedChildren = node.children ? node.children.map(processNode).filter(child => child !== undefined) : [];
                if ((keyPrefix === 'cat' || keyPrefix === 'subcat') && processedChildren.length === 0) {
                    return undefined;
                }
                if (!excludedKeys.includes(key)) {
                    return {
                        key: key,
                        id: node.id,
                        label: node.nom,
                        coef: node.coef,
                        className: node.scope,
                        pos: node.pos,
                        visibility: node.visibility,
                        description: node.description,
                        type: node.type,
                        aspect: node.aspect ? node.aspect : null,
                        children: node.children ? node.children.map(child => processNode(child)).filter(child => child !== undefined) : [],
                    };
                }
            };
            const sdata = bankAptitudesOnCreation.categories.map(category =>
                processNode(category)
            );
            setNodes(sdata.filter(s => s !== undefined));
        }
    }, [bankAptitudesOnCreation, addedApt, excludedKey]);

    useEffect(() => {
        let data = [];
        let popedKeys = [];

        if (projectAptitudes && projectAptitudes.categories) {
            const processNode = (node) => {
                const keyPrefix = node.scope === 'category' ? 'cat' :
                    node.scope === 'subcategory' ? 'subcat' : 'apt';
                const key = `${keyPrefix}-${node.id}`;

                if (keyPrefix === 'apt') {
                    popedKeys.push(key);
                }

                let processedNode = {
                    key: key,
                    id: node.id,
                    label: node.nom,
                    coef: node.coef,
                    className: node.active_state == 1 ? node.scope : 'inactive',
                    pos: node.pos,
                    scope: node.scope,
                    visibility: node.visibility,
                    description: node.description,
                    type: node.type,
                    aspect: node.aspect ? node.aspect : null,
                    children: node.children ? node.children.map(child => processNode(child)) : [],
                    active_mcq: node.active_mcq,
                    active_state: node.active_state
                };

                // Ajouter les questions si le noeud est une aptitude
                if (node.scope === 'aptitude' && node.questions) {
                    processedNode.questions = node.questions.map(question => ({
                        id: question.id,
                        id_aptitude: question.id_aptitude,
                        lang: question.lang,
                        scope: node.scope,
                        question: question.question,
                        type: question.type,
                        pos: question.pos,
                        correct_answers: question.correct_answers,
                        created_at: question.created_at,
                        updated_at: question.updated_at,
                        created_by: question.created_by,
                        updated_by: question.updated_by,
                        options: question.options ? question.options.map(option => ({
                            id: option.id,
                            id_question: option.id_question,
                            value: option.value,
                            pos: option.pos,
                            created_at: option.created_at,
                            updated_at: option.updated_at,
                            created_by: option.created_by,
                            updated_by: option.updated_by
                        })) : [],
                        active_mcq: node.active_mcq
                    }));
                }

                return processedNode;
            };

            data = projectAptitudes.categories.map(category =>
                processNode(category)
            );
        }
        setNodesInProject(data);
        setExcludedKey(popedKeys);
    }, [projectAptitudes]);


    useEffect(() => {
        let IdCollabs = collabsIds.map(collab => collab.id_collab)
        let collabsListed = collabsNames.filter(collab => IdCollabs.includes(collab.id))
        collabsListed = collabsListed.map(collab => {
            let sc = collabsIds.find(c => c.id_collab == collab.id)
            return {
                ...collab,
                active_mcq: parseInt(sc.active_mcq),
                latest_mcq_response: sc.latest_mcq_response,
                last_responses_number: sc.last_responses_number,
                last_response_date: sc.last_response_date
            }
        })
        setCollabsList(collabsListed);
        setMangersList(collabsNames.filter(collab => managersIds.includes(collab.id)))
    }, [managersIds, collabsIds])

    useEffect(() => {
        if (activeIndex == 2) {
            dispatch(getProjectAptitudes({ id_project: onCreateProject.id }))
        }
        if (activeIndex == 3 || activeIndex == 4) {
            dispatch(getProjectMembersAndManagers({ id_project: onCreateProject.id }))
        }
        if (activeIndex == 5) {
            if (mode === 'edit') {
                dispatch(getProjectMembersAndManagers({ id_project: onCreateProject.id }))
                dispatch(getProjectProgress({ id_project: onCreateProject.id, session: onCreateProject.last_session_number }))
            }
        }
    }, [activeIndex])

    useEffect(() => {
        if (onCreateProject && onCreateProject.id) {
            dispatch(getProjectQuestionsBank({ id_project: onCreateProject.id }));
        }
    }, [onCreateProject]);

    // ─── Event handlers ─────────────────────────────────────────────────

    const handleClose = () => {
        setProject({
            nom: '',
            start_date: null,
            end_date: null,
            days_limit: 1,
            active: true,
            image_src: null
        });
        setValidFields({
            nom: false,
            start_date: false,
            tried: false,
        });
        setActiveIndex(0);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        dispatch(setCreateProjectModalVisible(false));
        dispatch(setOnCreateProject(null));
        dispatch(setProjectMode(null));
        dispatch(setProjectProgress(0));
        dispatch(setProjectProgressDetails([]))
        dispatch(setProjectMembers([]))
        dispatch(setProjectManagers([]))
        setIsIOnDatabase(false);
        setAddedApt([])
        setExcludedKey([])
        setSelectedKeys({})
        dispatch(setAddedAptitudes([]))
        dispatch(setProjectAptitudes([]))
        setNodes([]);
        setNodesInProject([])
        dispatch(getProjects())
        dispatch(setSessionEndDate(null))
        dispatch(setSessionStartDate(null))
    };

    const handleProjectNameChange = (e) => {
        if (e.target.value.trim() !== '' && e.target.value != null) {
            setValidFields({
                ...validFields,
                nom: true
            });
        } else {
            setValidFields({
                ...validFields,
                nom: false
            });
        }
        setProject({
            ...project,
            nom: e.target.value
        });
    };

    const extractDataForExcel = (data) => {
        const results = [];
        const traverseNodes = (node, category = '', subCategory = '') => {
            if (node.scope === 'category') {
                category = node.label;
                subCategory = '';
            } else if (node.scope === 'subcategory') {
                subCategory = node.label;
            }
            if (node.scope === 'aptitude') {
                const row = {
                    Catégorie: category,
                    Coefficient: node.coef || 'N/A',
                    Sous_Catégorie: subCategory,
                    Coefficient1: node.coef || 'N/A',
                    Théorique_Pratique: node.aspect || 'N/A',
                    Aptitude: node.label,
                    Description: node.description || 'No description provided',
                    Coefficient2: node.coef || 'N/A'
                };
                results.push(row);
            }
            if (node.children && node.children.length) {
                node.children.forEach(child => traverseNodes(child, category, subCategory));
            }
        };
        data.forEach(node => traverseNodes(node));
        return results;
    };

    const extractExcelProject = (project, name) => {
        if (mode === 'edit' && nodesInProject.length > 0) {
            let data = extractDataForExcel(project);
            ExcelManager.getInstance().generateAndDownloadExcelFromData(data, name);
        }
    }

    const handleProjectDateChangeStart = (e) => {
        if (e.value != '' && e.value != null) {
            setValidFields({
                ...validFields,
                start_date: true
            });
        } else {
            setValidFields({
                ...validFields,
                start_date: false
            });
        }
        setProject({
            ...project,
            start_date: e.value
        });
        if (project.end_date != null) {
            if (project.end_date < e.value) {
                setProject({
                    ...project,
                    end_date: e.value
                });
            }
        }
    };

    const handleProjectDateChangeEnd = (e) => {
        setProject({
            ...project,
            end_date: e.value
        });
        console.log(e.value)
    };

    const handleProjectActive = (param) => {
        setProject({
            ...project,
            active: param
        });
    };

    const handleProjectActiveImageButton = () => {
        setProject({
            ...project,
            active: !project.active
        });
    };

    //handling image
    const handleImageChange = (e) => {
        if (e.target.files[0].size > 51200) {
            alert('File is too large, please upload a file less than 50KB.');
            return;
        }
        processFile(e.target.files[0]);
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleDeleteImage = () => {
        setProject({ ...project, image_src: null });
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const processFile = (file) => {
        if (file && file.type.startsWith('image')) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setProject({
                    ...project,
                    image_src: reader.result
                });
            };
            reader.readAsDataURL(file);
        } else {
            alert('Please select an image file.');
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file.size > 51200) {
            alert('File is too large, please upload a file less than 50KB.');
            return;
        }
        processFile(file);
    };

    const handleProjectDelay = (e) => {
        setProject({
            ...project,
            days_limit: e.value >= 0 ? e.value : 0
        });
    };
    const handleProjectNeededCollabs = (e) => {
        setProject({
            ...project,
            needed_collabs: e.value >= 0 ? e.value : 0
        });
    };

    const confirm1 = () => {
        if (mode != "edit") {
            if (isInDatabase) {
                confirmDialog({
                    message: <Langs str="CONFIRM_PROJECT_CANCEL" />,
                    confirmLabel: <Langs str="SAVE" />,
                    cancelLabel: <Langs str="DISCARD" />,
                    onConfirm: saveAfterCancel,
                    onCancel: deleteAfterCancel,
                });
            } else {
                handleClose();
            }
        } else {
            handleClose();
        }
    };
    const confirmDeleteCatSub = (id) => {
        // "Delete" is the second button, not a dismissal: closing the dialog does neither.
        confirmDialog({
            message: <Langs str="DELETE_ASSOCIATED" />,
            confirmLabel: <Langs str="KEEP" />,
            cancelLabel: <Langs str="DELETE" />,
            onConfirm: () => { deleteCatSubFromProject(true, id) },
            onCancel: () => { deleteCatSubFromProject(false, id) },
        });
    };
    const confirmDeleteCollab = (id) => {
        confirmDialog({
            message: <Langs str="REMOVE_COLLAB_FROM_PROJECT" />,
            danger: true,
            confirmLabel: <Langs str="REMOVE" />,
            onConfirm: () => { dispatch(addRemoveProjectCollabsManagers({ id_project: onCreateProject.id, removed_collabs: [id] })) },
        });
    };
    const confirmDeleteManager = (id) => {
        confirmDialog({
            message: <Langs str="REMOVE_MANAGER_FROM_PROJECT" />,
            danger: true,
            confirmLabel: <Langs str="REMOVE" />,
            onConfirm: () => { dispatch(addRemoveProjectCollabsManagers({ id_project: onCreateProject.id, removed_managers: [id] })) },
        });
    };

    const deleteCatSubFromProject = (keeper, id) => {
        dispatch(deleteProjectCatSub(
            {
                keep: keeper,
                id_project: onCreateProject?.id,
                id_category: id
            }
        ))
    }

    const confirmDeleteApt = (id) => {
        confirmDialog({
            message: <Langs str="DELETE_APTITUDE_CONFIRM" />,
            danger: true,
            confirmLabel: <Langs str="DELETE" />,
            onConfirm: () => { deleteAptFromProject(id) }
        });
    };

    const deleteAptFromProject = (id) => {
        dispatch(deleteProjectAptitude(
            {
                id_project: onCreateProject?.id,
                id_aptitude: id
            }
        ))
    }

    const saveAfterCancel = () => {
        handleClose();
    };

    const deleteAfterCancel = () => {
        dispatch(deleteProject({ id_project: project.id }));
        setSelectedKeys({});
        handleClose();
    };

    //datelist functions
    function handleDateListSpan(sd, ed, d) {
        if (sd == null || d == null) {
            setDatesList([]);
        } else {
            let startDate = moment(sd, "DD/MM/YYYY");
            let endDate = ed ? moment(ed, "DD/MM/YYYY") : moment(sd, "DD/MM/YYYY").add(2, 'y');
            let dates = [];
            let currentDate = startDate.clone();
            while (currentDate <= endDate) {
                dates.push(currentDate.format("DD/MM/YYYY"));
                currentDate.add(d, 'days');
            }
            setDatesList(dates);
        }
    }

    const handleProjectDetailsSave = () => {
        if (!validFields.nom || !validFields.start_date) {
            setValidFields({
                ...validFields,
                tried: true
            });
        } else {
            setValidFields({
                ...validFields,
                tried: false
            });
        }
        if (validFields.nom && validFields.start_date) {
            dispatch(setOnCreateProject(project));
            dispatch(addEditVcompProject({
                ...project,
                start_date: moment(project.start_date).format("DD/MM/YYYY"),
                end_date: project.end_date ? moment(project.end_date).format("DD/MM/YYYY") : null,
                days_limit: project.days_limit * 7
            }));
        }
    };

    const handleAddDefaultProjectForm = () => {
        console.log(selectedKeys)
        if (selectedKeys) {
            let aptKeys = Object.keys(selectedKeys).filter(key => key);
            if (aptKeys.length > 0) {
                const aptitudes = aptKeys.map(aptitude => {
                    if (aptitude.split('-')[0] === 'apt') {
                        return parseInt(aptitude.split('-')[1])
                    }
                }).filter(aptitude => aptitude != null);
                const id_project = onCreateProject.id;
                const result = {
                    id_project,
                    aptitudes
                };
                setAddedApt(aptKeys)
                setExcludedKey(aptKeys)
                if (aptitudes.length > 0) {
                    dispatch(addDefaultProjectForm(result))
                }
                setSelectedKeys([])
            } else {
                setActiveIndex(activeIndex >= 2 ? 0 : activeIndex + 1);
            }
        } else {
            setActiveIndex(activeIndex >= 2 ? 0 : activeIndex + 1);
        }
    };

    //algorithm for allowing dynamic playing
    function isChild(objects, searchKey) {
        function searchChildren(children) {
            return children.some(child => {
                if (child.key === searchKey) {
                    return true;
                }
                if (child.children && child.children.length > 0) {
                    return searchChildren(child.children);
                }
                return false;
            });
        }
        return objects.some(obj => {
            if (obj.children && obj.children.length > 0) {
                return searchChildren(obj.children);
            }
            return false;
        });
    }
    const dragDropAptitudes = (event) => {
        const { value, dragNode, dropNode } = event;
        if (dropNode) {
            if (dropNode.key.trim().toLowerCase().includes("apt")) {
                return
            }
        }
        const hasCategoryChild = dragNode.children && dragNode.children.some(child => child.key.trim().toLowerCase().includes("cat"));
        if (hasCategoryChild && dropNode) {
            return
        }
        if (dropNode && isChild(value, dropNode.key) &&
            dropNode.key.trim().toLowerCase().includes("cat") &&
            !dragNode.key.trim().toLowerCase().includes("apt")) {
            return
        }
        setNodesInProject(value);
    }

    const handleAddtProjectFormEdit = () => {
        const categories = [];
        const aptitudes = []
        console.log(nodesInProject)
        nodesInProject.forEach((node, index) => {
            if (node.key.trim().toLowerCase().includes("cat")) {
                let idParent = node.id
                categories.push(
                    {
                        id: node.id,
                        pos: index
                    }
                )
                if (node.children && node.children.length > 0) {
                    node.children.forEach((childCat, index) => {
                        if (childCat.key.trim().toLowerCase().includes("cat")) {
                            categories.push(
                                {
                                    id: childCat.id,
                                    id_parent: idParent,
                                    pos: index
                                }
                            )
                            if (childCat.children && childCat.children.length > 0) {
                                childCat.children.forEach((childApt, index) => {
                                    if (childApt.key.trim().toLowerCase().includes("apt")) {
                                        aptitudes.push({
                                            id: childApt.id,
                                            id_category: childCat.id,
                                            pos: index
                                        })
                                    }
                                })
                            }
                        }
                        if (childCat.key.trim().toLowerCase().includes("apt")) {
                            aptitudes.push(
                                {
                                    id: childCat.id,
                                    id_category: idParent,
                                    pos: index
                                }
                            )
                        }
                    })
                }
            }
            if (node.key.trim().toLowerCase().includes("apt")) {
                aptitudes.push(
                    {
                        id: node.id,
                        id_category: null,
                        pos: index

                    }
                )
            }

        })
        if (onCreateProject && onCreateProject.id) {
            dispatch(reorderProjectForm({
                id_project: onCreateProject.id,
                categories: categories,
                aptitudes: aptitudes
            }))
        }
    }

    const handleNodeDoubleClick = (e) => {
        if (e.node.visibility || e.node.scope === 'aptitude') {
            let subcat = isChild(nodesInProject, e.node.key);
            showAddElementModalForElement(e.node, subcat)
        }
    }

    function showAddElementModalForElement(element, subcat) {
        dispatch(setAddElementModalVisibility({ visibility: true, element: element, subcategory: subcat, isEdit: 1 }))
        dispatch(setSelectedAptitudeForQuestion(element))
    }

    // ─── Node templates (used by EditFormTab tree) ──────────────────────

    const nodeTemplate = (node) => {
        let subcat = isChild(nodesInProject, node.key);
        let type = node ? node.key.split('-')[0] : null;

        const hasQuestions = node.questions && node.questions.length > 0;

        return (
            <div className="node-container">
                <span style={{ color: node.active_state === 0 ? 'inherit' : 'inherit' }}>{node.label}</span>&nbsp;
                {node.aspect === 'theoretical' && <b>[T]</b>}
                {node.aspect === 'practical' && <b>[P]</b>}
                {hasQuestions && <b><span style={{ color: '#008000' }}>[Q]</span></b>}
                {node.visibility === 2 && <i className="pi pi-lock"></i>}
                <div className="node-button">
                    <Row>
                        {isMobile === 1 && node.visibility == 1 && (
                            <ImageButton
                                image={editIcon}
                                imageFocus={editIconFocus}
                                onClick={() => {
                                    showAddElementModalForElement(node, subcat);
                                }}
                                active={true}
                                width={32}
                            />
                        )}
                        {isMobile === 1 && (
                            <ImageButton
                                image={deleteIcon}
                                imageFocus={deleteIconFocus}
                                onClick={() => {
                                    if (type === "apt") {
                                        confirmDeleteApt(node.id);
                                    } else {
                                        confirmDeleteCatSub(node.id);
                                    }
                                }}
                                active={true}
                                width={32}
                            />
                        )}
                        {node.scope !== 'aptitude' && (
                            <ImageButton
                                image={addIcon}
                                imageFocus={addIconFocus}
                                onClick={() => {
                                    dispatch(setAddElementModalVisibility({
                                        visibility: true,
                                        element: node,
                                        subcategory: subcat,
                                        isEdit: 0
                                    }));
                                }}
                                active={true}
                                width={32}
                            />
                        )}
                    </Row>
                </div>
            </div>
        );
    };

    const nodeTemplatePublic = (node) => {
        const hasQuestions = node.questions && node.questions.length > 0;
        return (
            <div className="node-container">
                <span>{node.label}</span>&nbsp;{node.aspect === 'theoretical' && <b>[T]</b>}{node.aspect === 'practical' && <b>[P]</b>}&nbsp;{hasQuestions && <b><span style={{ color: '#FF4500' }}>[Q]</span></b>}
            </div>
        );
    }

    // ─── MCQ handlers (used by MembersTab) ──────────────────────────────

    const handleActivateCollabMcq = (e, rowData) => {
        if (e.value === true) {
            setCollabsList(
                collabsList.map(collab => {
                    if (collab.id === rowData.id) {
                        return { ...collab, active_mcq: 1 }
                    }
                    return collab
                })
            )
            if (onCreateProject && onCreateProject.id) {
                dispatch(activateMcqCollabs({ id_project: onCreateProject.id, activate: [rowData.id] }))
            }
        }
        if (e.value === false) {
            setCollabsList(
                collabsList.map(collab => {
                    if (collab.id === rowData.id) {
                        return { ...collab, active_mcq: 0 }
                    }
                    return collab
                })
            )
            if (onCreateProject && onCreateProject.id) {
                dispatch(activateMcqCollabs({ id_project: onCreateProject.id, deactivate: [rowData.id] }))
            }
        }
    }

    const handleActivateAllMcq = (e) => {
        const isActive = e.value === true ? 1 : 0;
        setCollabsList(
            collabsList.map(collab => ({ ...collab, active_mcq: isActive }))
        );
        if (onCreateProject && onCreateProject.id) {
            const ids = collabsList.map(collab => collab.id);
            if (isActive === 1) {
                dispatch(activateMcqCollabs({ id_project: onCreateProject.id, activate: ids }));
            } else {
                dispatch(activateMcqCollabs({ id_project: onCreateProject.id, deactivate: ids }));
            }
        }
    };

    const viewMcqResultsModal = (id, lrn, lrd) => {
        dispatch(setCollabMcqResultsModalVisibility(true))
        dispatch(setCollabIdMcqResults(id))
        dispatch(setLastResponseNumber({ response_number: lrn, created_at: lrd }))
    }

    function checkStartDateValidity() {
        if (mode == 'edit') {
            if (onCreateProject && onCreateProject.start_date) {
                if (moment(onCreateProject.start_date).isBefore(moment())) {
                    return true
                }
            }
        }
        return false
    }

    // ─── Tab content switcher ───────────────────────────────────────────

    const rightView = (index) => {
        switch (index) {
            case 0:
                return (
                    <ProjectDetailsTab
                        project={project}
                        validFields={validFields}
                        mode={mode}
                        isMobile={isMobile}
                        fileInputRef={fileInputRef}
                        onImageChange={handleImageChange}
                        onImageClick={handleImageClick}
                        onDeleteImage={handleDeleteImage}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        onProjectNameChange={handleProjectNameChange}
                        onDateChangeStart={handleProjectDateChangeStart}
                        onDateChangeEnd={handleProjectDateChangeEnd}
                        onDelayChange={handleProjectDelay}
                        onNeededCollabsChange={handleProjectNeededCollabs}
                        onActiveChange={handleProjectActive}
                        onSave={handleProjectDetailsSave}
                        checkStartDateValidity={checkStartDateValidity}
                    />
                );
            case 1:
                return (
                    <PublicFormTab
                        isMobile={isMobile}
                        mode={mode}
                        nodes={nodes}
                        selectedKeys={selectedKeys}
                        onSelectionChange={setSelectedKeys}
                        nodeTemplatePublic={nodeTemplatePublic}
                        onPrevious={() => setActiveIndex(0)}
                        onNext={handleAddDefaultProjectForm}
                    />
                );
            case 2:
                return (
                    <QuestionsTab
                        isMobile={isMobile}
                        mode={mode}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        onCreateProject={onCreateProject}
                        selectedKeys={selectedKeys}
                        onSelectionChange={setSelectedKeys}
                        handleAddDefaultProjectForm={handleAddDefaultProjectForm}
                    />
                );
            case 3:
                return (
                    <EditFormTab
                        isMobile={isMobile}
                        mode={mode}
                        nodesInProject={nodesInProject}
                        expandedKeysEdit={expandedKeysEdit}
                        onToggleExpanded={setExpandedKeysEdit}
                        expandAll={expandAll}
                        collapseAll={collapseAll}
                        nodeTemplate={nodeTemplate}
                        onNodeDoubleClick={handleNodeDoubleClick}
                        onDragDrop={dragDropAptitudes}
                        projectAptitudes={projectAptitudes}
                        onCreateProject={onCreateProject}
                        onSetExcelModalVisibility={setExcelModalVisibility}
                        onExtractExcelProject={extractExcelProject}
                        onPrevious={() => setActiveIndex(1)}
                        onNext={handleAddtProjectFormEdit}
                    />
                );
            case 4:
                return (
                    <MembersTab
                        isMobile={isMobile}
                        mode={mode}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        collabsList={collabsList}
                        dtCollabs={dtCollabs}
                        onConfirmDeleteCollab={confirmDeleteCollab}
                        onActivateCollabMcq={handleActivateCollabMcq}
                        onActivateAllMcq={handleActivateAllMcq}
                        onViewMcqResults={viewMcqResultsModal}
                    />
                );
            case 5:
                return (
                    <ManagersTab
                        isMobile={isMobile}
                        mode={mode}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        mangersList={mangersList}
                        dtManagers={dtManagers}
                        onConfirmDeleteManager={confirmDeleteManager}
                        onClose={handleClose}
                    />
                );
            case 6:
                return (
                    <ProgressTab
                        isMobile={isMobile}
                        mode={mode}
                        setActiveIndex={setActiveIndex}
                    />
                );
            default:
                return (
                    <div>
                        <h1>Welcome</h1>
                        <p>Please select an option from the left menu.</p>
                    </div>
                );
        }
    };

    function body() {
        return (
            <Row className={` ${styles.mainContainer}`}>
                <Col lg={2} className={` ${styles.leftContainer}`}>
                    <Row className="mt-4">
                        <NavigationMenu
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                            isMobile={isMobile}
                            mode={mode}
                            isInDatabase={isInDatabase}
                            projectName={project.nom}
                            onConfirmClose={confirm1}
                            onSaveDetails={handleProjectDetailsSave}
                        />
                    </Row>
                </Col>
                {isMobile === 1 && <Col lg={1}></Col>}
                <Col lg={isMobile !== 1 ? 10 : 8} className={` ${styles.rightContainer}`}>
                    {isMobile !== 1 &&
                        <NavigationMenu
                            activeIndex={activeIndex}
                            setActiveIndex={setActiveIndex}
                            isMobile={isMobile}
                            mode={mode}
                            isInDatabase={isInDatabase}
                            projectName={project.nom}
                            onConfirmClose={confirm1}
                            onSaveDetails={handleProjectDetailsSave}
                        />
                    }
                    {rightView(activeIndex)}
                </Col>
            </Row>
        );
    }


    const header = () => {
        return (
            <div>
                {isInDatabase && onCreateProject ? onCreateProject.nom : <Langs str="Create new Project" />}
            </div>
        );
    };

    const footer = () => {
        return;
    };

    return (
        <div className="card flex justify-content-center">
            <Dialog
                visible={visible}
                style={{ width: '100vw', height: '100vh', maxHeight: "100%", backgroundColor: "grey" }}
                onHide={() => { isInDatabase ? confirm1() : handleClose(); }}
                draggable={false}
                resizable={false}
                header={header}
                footer={footer}
                className="customDialog"
            >
                {body()}
            </Dialog>
            <AddElementModal />
            <AddMembersModal />
            <McqResultsModal />
            <ExcelInputModal
                visibility={excelModalVisibility}
                setVisibility={(e) => { setExcelModalVisibility(e) }}
            />
        </div>
    );
}
